import * as RefApi from 'saas/references/api';
import * as RefConstants from 'saas/references/constants';
import { createAction } from 'redux-actions';
import { updateInterventionTimeUnitAction } from './form';
import * as WorkerApi from 'saas/users/api';

export const fetchRequirementsAction = createAction('case.FETCH_REQUIREMENTS');
export const fetchRequirementsSuccessAction = createAction(
  'case.FETCH_REQUIREMENTS_SUCCESS'
);

export const fetchRequirements = siteCase => (dispatch, getState) => {
  if (getState().requirements.isFetching) {
    return Promise.resolve();
  }

  dispatch(fetchRequirementsAction());

  const doFetch = () =>
    Promise.all([
      RefApi.getReferencesByType(RefConstants.TIME_UNIT, siteCase),
      WorkerApi.getAllWorkers(),
    ]);

  // Fetching requirements and planning
  const promise = doFetch().then(response => {
    dispatch(
      fetchRequirementsSuccessAction({
        timeUnits: response[0],
        workers: response[1],
      })
    );

    dispatch(updateInterventionTimeUnitAction(response[0][0].id));
  });

  return promise;
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/interventions/actions/requirements.js